import { __rest } from "tslib";
import * as React from 'react';
const ChevronLeftSmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10.8448202,5.14270801 C11.0394183,5.33600267 11.0404716,5.64963633 10.8476779,5.84372938 L7.71273205,8.99980356 L10.8488003,12.1634729 C11.0414976,12.3578663 11.0408107,12.6714558 10.8472635,12.865003 C10.6532807,13.0582298 10.3404929,13.0576181 10.1479487,12.8643191 L6.29891136,9.00019644 L10.1421589,5.14494052 C10.3357619,4.95073257 10.649987,4.9497342 10.8448202,5.14270801 Z" })));
};
ChevronLeftSmall.displayName = 'ChevronLeftSmall';
export default ChevronLeftSmall;
//# sourceMappingURL=ChevronLeftSmall.js.map